import Vue from "vue";
import Router from "vue-router";
import VueRouter, { RouteConfig } from "vue-router";
import VueAnalytics from "vue-analytics";

import NotFound from "@/views/NotFound.vue";
import Home from "@/views/Home.vue";
import BusinessHome from "@/views/business/Home.vue";
import Company from "@/views/Company.vue";
import Technology from "@/views/Technology.vue";
import Privacy from "@/views/Privacy.vue";
import PrivacyAd from "@/views/PrivacyAd.vue";
import PrivacyService from "@/views/PrivacyService.vue";
import AntiSocial from "@/views/AntiSocial.vue";
import Security from "@/views/Security.vue";
import Sitemap from "@/views/Sitemap.vue";
import People from "@/views/People.vue";
import NewsHome from "@/views/news/Home.vue";
import NewsDetail from "@/views/news/Detail.vue";

import Contact from "@/views/Contact.vue";

Vue.use(Router);

const routes: RouteConfig[] = [
  // START ROUTING - use for sitemaps generator.
  {
    path: "/",
    name: "index",
    component: Home,
  },
  {
    path: "/business",
    component: BusinessHome,
    meta: { title: "事業領域" },
  },
  {
    path: "/company",
    component: Company,
    meta: { title: "会社情報" },
  },
  {
    path: "/technology",
    component: Technology,
    meta: { title: "テクノロジー" },
  },
  {
    path: "/news",
    component: NewsHome,
    meta: { title: "ニュース" },
  },
  {
    path: "/news/:articleId",
    component: NewsDetail,
    meta: { title: "ニュース" },
  },
  {
    path: "/policy/privacy",
    component: Privacy,
    meta: { title: "プライバシーポリシー" },
  },
  {
    path: "/policy/privacy/ad",
    component: PrivacyAd,
    meta: { title: "行動ターゲティング広告サービス等について" },
  },
  {
    path: "/policy/privacy/service",
    component: PrivacyService,
    meta: { title: "各サービスのプライバシーポリシー" },
  },
  {
    path: "/policy/antisocial",
    component: AntiSocial,
    meta: { title: "反社会的勢力に対する基本方針" },
  },
  {
    path: "/policy/security",
    component: Security,
    meta: { title: "情報セキュリティ基本方針" },
  },
  {
    path: "/contact",
    component: Contact,
    meta: { title: "お問い合わせ" },
  },
  {
    path: "/sitemap",
    component: Sitemap,
    meta: { title: "サイトマップ" },
  },
  // END ROUTING - use for sitemaps generator.
  {
    path: "/people",
    component: People,
    meta: { title: "People（人への想い）" },
  },
  {
    path: "/business/space",
    redirect: "/business",
  },
  {
    path: "*",
    component: NotFound,
    meta: { title: "404 ページが見つかりませんでした (Page Not Found)" },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash.length > 0) {
      return { selector: to.hash };
    }
    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  },
});

const HTML_SUFFIX = ".html";
router.beforeEach((to, from, next) => {
  const t = to.meta && to.meta.title;
  if (t && t !== "") {
    document.title = `${t} | 株式会社スタジアム`;
  } else {
    document.title = "株式会社スタジアム";
  }

  if (to.path.endsWith(HTML_SUFFIX)) {
    next(to.path.replace(HTML_SUFFIX, ""));
  }
  next();
});

if (process.env.NODE_ENV === "production") {
  Vue.use(VueAnalytics, {
    id: "UA-140134247-1",
    router,
  });
}

export default router;
